import { Navigate, useLocation } from 'react-router';
import { checkAuth, isMaintenance, getUser } from './auth';
import { Route as FunctionsRoute } from './functions';

export const AuthenticatedRoute = ({ children }) => {
  const location = useLocation();

  const redirectToMaintenance = getUser()?.isMaintainer ? false : isMaintenance() ? true : false;
  if (redirectToMaintenance) {
    return <Navigate to="/maintenance" replace state={{ from: location.pathname }} />;
  }
  if (!checkAuth()) {
    return <Navigate to="/sign-in" replace state={{ from: location.pathname }} />;
  }
  const path = window.location.pathname;
  if (!FunctionsRoute.authorizeLocationPath(path)) {
    return <Navigate to="/access-denied" replace state={{ from: location.pathname }} />;
  }
  return children;
};

export const ToAuthenticateRoute = ({ children }) => {
  const location = useLocation();
  
  if (checkAuth() && !isMaintenance()) {
    return <Navigate to="/" replace state={{ from: location.pathname }} />;
  }
  return children;
};

export const PublicRoute = ({ children }) => {
  const location = useLocation();

  const redirectToMaintenance = getUser()?.isMaintainer ? false : isMaintenance() ? true : false;
  if (redirectToMaintenance) {
    return <Navigate to="/maintenance" replace state={{ from: location.pathname }} />;
  }
  return children;
};